import { render, staticRenderFns } from "./ContentInput.vue?vue&type=template&id=71391b20&"
import script from "./ContentInput.vue?vue&type=script&lang=js&"
export * from "./ContentInput.vue?vue&type=script&lang=js&"
import style0 from "./ContentInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentInput.vue"
export default component.exports